<template>
    <div class="tyn-root">
        <Header></Header>
        
        <div class="tyn-content tyn-contact has-aside-base">
            <div class="tyn-aside tyn-aside-base">
                <div class="tyn-aside-head">
                    <div class="tyn-aside-head-text">
                        <h3 class="tyn-aside-title tyn-title">Normativas</h3>
                        <p class="tyn-subtext">
                            Envie suas normativas para a IA utilizar
                        </p>
                    </div>
                    <div class="tyn-aside-head-tools">
                        <ul class="tyn-list-inline gap gap-3">
                            <li>
                                <button class="btn btn-icon btn-success-add btn-md btn-pill"   v-if="!isUsuarioContato && (isAdmContrato == 'Sim' || isAdm || user.usuario.idContrato == 0 || user.usuario.dsLogin == 'aline.oliveira@negociospublicos.com.br')"
                                        @click="showModal(showModalNormativa,'ModalNormativa')"
                                        title="Nova Normativa"
                                        style="background: linear-gradient(135deg, #2563eb 0%, #00d084 100%) !important; border: none !important;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2" />
                                    </svg>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
                
                <div class="tyn-aside-body" data-simplebar>
                    <!-- SEARCH MODERNIZADO -->
                    <div class="tyn-aside-search">
                        <div class="search-box-modern">
                            <div class="search-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
                                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                                </svg>                            
                            </div>
                            <input 
                                type="text" 
                                class="search-input-modern" 
                                placeholder="Pesquisar normativas…" 
                                v-model="pagFilter"
                            >
                        </div>
                    </div>

                    <div class="tyn-aside-row pt-0 mt-2">
                        <span class="tyn-subtext" v-if="lstNormas">
                            {{ lstNormas.length }} {{ (lstNormas.length == 1 ? 'norma enviada' : 'normas enviadas') }}
                        </span>
                    </div>

                    <!-- LISTA MODERNIZADA -->
                    <ul class="tyn-aside-list">
                        <li :class="'tyn-aside-item js-toggle-main '+(norma && item.idNorma == norma.idNorma ? 'active':'')" 
                            v-for="(item, index) in normasFiltradas" 
                            :key="index"
                            @click="seleciona(item)">
                            <div class="tyn-media-group">
                                <div class="tyn-media tyn-size-sm">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-file-earmark-text" viewBox="0 0 16 16">
                                        <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5"/>
                                        <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/>
                                    </svg>
                                </div>
                                <div class="tyn-media-col">
                                    <div class="content">{{ item.nmNorma || item.dsNome }}</div>
                                    <div class="norma-lista-descricao" v-if="item.dsNorma">{{ item.dsNorma }}</div>
                                    <div class="meta-info">
                                        <span v-if="item.flProcessado == 2" class="badge-status badge-success">Processado</span>
                                        <span v-else-if="item.flProcessado == 1" class="badge-status badge-processing">Processando</span>
                                        <span v-else class="badge-status badge-pending">Pendente</span>
                                    </div>
                                </div>
                                <div class="tyn-media-option">
                                    <ul class="tyn-media-option-list">
                                        <li class="d-flex">
                                            <button class="btn btn-icon btn-md btn-pill btn-light me-2" title="Renomear" v-if="podeAlterarNorma(item)" @click.stop="renomear(item)">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
                                                    <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
                                                </svg>
                                            </button>
                                            <button class="btn btn-icon btn-md btn-success-add btn-pill me-2" @click.stop="download(item.urlArquivo, item.dsNome)">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-box-arrow-down" viewBox="0 0 16 16">
                                                    <path fill-rule="evenodd" d="M3.5 10a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0 0 1h2A1.5 1.5 0 0 0 14 9.5v-8A1.5 1.5 0 0 0 12.5 0h-9A1.5 1.5 0 0 0 2 1.5v8A1.5 1.5 0 0 0 3.5 11h2a.5.5 0 0 0 0-1z" />
                                                    <path fill-rule="evenodd" d="M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708z" />
                                                </svg>
                                            </button>
                                            <button class="btn btn-icon btn-md btn-pill btn-light btn-remover" v-if="!isUsuarioContato && (isAdmContrato == 'Sim' || isAdm || user.usuario.idContrato == 0 || user.usuario.dsLogin == item.dsLoginInclusao)" @click.stop="removeNormativa(item.idNorma)">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"></path>
                                                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"></path>
                                                </svg>
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            
            <!-- MAIN CONTENT -->
            <div class="tyn-main tyn-content-inner" id="tynMain">
                <ul class="tyn-list-inline d-md-none translate-middle-x position-absolute start-50 top-0 z-1">
                    <li>
                        <button class="btn btn-icon btn-pill btn-white js-toggle-main" @click="fechar">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                            </svg>
                        </button>
                    </li>
                </ul>

                <div class="norma-dados" v-if="norma">
                    <div v-if="!editandoDados" class="norma-dados-view">
                        <div class="norma-dados-texto">
                            <h4 class="norma-dados-nome">{{ nomeNormaExibido }}</h4>
                            <p class="norma-dados-descricao" v-if="norma.dsNorma">{{ norma.dsNorma }}</p>
                            <p class="norma-dados-descricao is-empty" v-else>Sem descrição informada</p>
                        </div>
                        <button type="button"
                                class="btn btn-sm btn-editar-norma"
                                v-if="podeEditarNorma"
                                @click="iniciarEdicao">
                            Editar
                        </button>
                    </div>
                    <div v-else class="norma-dados-form">
                        <div class="mb-2">
                            <label class="form-label" for="edicaoNmNorma">Nome</label>
                            <input id="edicaoNmNorma"
                                   type="text"
                                   class="form-control"
                                   maxlength="150"
                                   v-model="edicao.nmNorma"
                                   placeholder="Nome da normativa" />
                            <small class="text-muted">{{ (edicao.nmNorma || '').length }}/150</small>
                        </div>
                        <div class="mb-2">
                            <label class="form-label" for="edicaoDsNorma">Descrição</label>
                            <textarea id="edicaoDsNorma"
                                      class="form-control"
                                      maxlength="500"
                                      rows="3"
                                      v-model="edicao.dsNorma"
                                      placeholder="Descrição da normativa"></textarea>
                            <small class="text-muted">{{ (edicao.dsNorma || '').length }}/500</small>
                        </div>
                        <div class="d-flex gap-2">
                            <button type="button" class="btn btn-sm btn-editar-norma" :disabled="salvandoDados" @click="salvarDados">
                                {{ salvandoDados ? 'Salvando…' : 'Salvar' }}
                            </button>
                            <button type="button" class="btn btn-sm btn-light" :disabled="salvandoDados" @click="cancelarEdicao">
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>

                <div v-if="norma" :class="'pdf-container ' + (norma.urlArquivo.includes('.pdf') || norma?.urlArquivo.includes('.txt')?'':'d-none')">
                    <!-- Alertas de Status -->
                    <div class="alert-floating" v-if="norma.flProcessado == 0">
                        <div class="alert alert-warning" role="alert">
                            <span role="status">Normativa não processada</span>
                            <button class="btn btn-warning btn-sm ms-2" type="button" @click="reprocessar(norma.idNorma)" v-if="isAdmContrato == 'Sim' || isAdm || user.usuario.idContrato == 0 || user.usuario.dsLogin == 'aline.oliveira@negociospublicos.com.br'">
                                <i class="fas fa-sync-alt"></i> Reprocessar
                            </button>
                        </div>
                    </div>
                    <div class="alert-floating" v-if="norma.flProcessado == 1">
                        <div class="alert alert-info" role="alert">
                            <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
                            <span role="status">Processando arquivo...</span>
                        </div>
                    </div>

                    <!-- Barra de Ações Flutuante -->
                    <!--<div class="action-bar-floating">
            <button class="btn-action btn-download" @click="download(norma.urlArquivo, norma.dsNome)" title="Download">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-box-arrow-down" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M3.5 10a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0 0 1h2A1.5 1.5 0 0 0 14 9.5v-8A1.5 1.5 0 0 0 12.5 0h-9A1.5 1.5 0 0 0 2 1.5v8A1.5 1.5 0 0 0 3.5 11h2a.5.5 0 0 0 0-1z" />
                    <path fill-rule="evenodd" d="M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708z" />
                </svg>
            </button>
            <button class="btn-action btn-delete" @click="removeNormativa(norma.idNorma)" title="Excluir">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                </svg>
            </button>
        </div>-->
                    <!-- PDF Viewer -->
                    <template v-if="norma.urlArquivo.includes('.pdf') || norma?.urlArquivo.includes('.txt')">
                        <div class="pdf-viewer" v-if="!reloadPdf">
                            <iframe :src="urlPdfViewer" width="100%" height="100%" />
                        </div>
                    </template>
                </div>
                <div :class="'docx-container ' + (norma?.urlArquivo.includes('.doc') || norma?.urlArquivo.includes('.docx')?' ':'d-none')">
                    <template v-if="norma">
                        <!-- Alertas de Status -->
                        <div class="alert-floating" v-if="norma?.flProcessado == 0">
                            <div class="alert alert-warning" role="alert">
                                <span role="status">Normativa não processada</span>
                                <button class="btn btn-warning btn-sm ms-2" type="button" @click="reprocessar(norma.idNorma)" v-if="isAdmContrato == 'Sim' || isAdm || user.usuario.idContrato == 0 || user.usuario.dsLogin == 'aline.oliveira@negociospublicos.com.br'">
                                    <i class="fas fa-sync-alt"></i> Reprocessar
                                </button>
                            </div>
                        </div>
                        <div class="alert-floating" v-if="norma?.flProcessado == 1">
                            <div class="alert alert-info" role="alert">
                                <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
                                <span role="status">Processando arquivo...</span>
                            </div>
                        </div>
                    </template>
                    
                    <div class="docx-wrapper" :class="{ 'is-loading': editorBusy }" style="height: 100%; overflow: auto;">
                        <div v-if="editorBusy" class="editor-overlay">
                            <div class="overlay-content">
                                <svg class="spinner" viewBox="0 0 50 50" aria-label="Carregando">
                                    <circle cx="25" cy="25" r="20" fill="none" stroke-width="5" />
                                </svg>
                                <p>Carregando documento…</p>
                            </div>
                        </div>

                        <ejs-documenteditorcontainer ref="docx"
                                                     :serviceUrl="`${urlApi}/DOCXEditor/`"
                                                     :isReadOnly="true"
                                                     :enableToolbar="false"
                                                     :enabelSelection="false"
                                                     :restrictEditing="true"
                                                     height="100%"
                                                     width="100%"
                                                     locale="pt-BR"
                                                     @beforeXmlHttpRequestSend="beforeSend" />
                    </div>
                </div>
                <div v-if="norma" :class="' ' + (norma?'':'d-none')">
                    <div class="col-12" v-if="!norma?.urlArquivo.includes('.pdf') && !norma?.urlArquivo.includes('.txt') && !norma?.urlArquivo.includes('.doc') && !norma?.urlArquivo.includes('.docx')">
                        <div class="alert alert-light text-center py-5 rounded-0" role="alert">
                            <h4>Pré-visualização indisponível</h4>
                            <p>
                                O formato deste documento não é compatível com a função de pré-visualização.
                            </p>
                        </div>
                        <iframe allow="fullscreen" :src="norma.urlArquivo"></iframe>
                    </div>
                </div>

            </div>
        </div>
        
        <!-- MODAIS HEADER -->
        <Modais></Modais>
    </div>
</template>
<script>
    import Header from '@/components/Header'
    import Modais from '@/components/Modais'

    import { urlApi, avisoToast, avisoErro } from '@/config/global'
    import axios from 'axios'
    import Swal from 'sweetalert2'
    import moment from 'moment'

    import { L10n, setCulture } from '@syncfusion/ej2-base'
    import ptBR from '@syncfusion/ej2-locale/src/pt-BR.json'
    import { PdfViewer, Navigation, Magnification, Print, TextSelection, LinkAnnotation, BookmarkView, ThumbnailView } from '@syncfusion/ej2-pdfviewer'
    PdfViewer.Inject( Navigation, Magnification, Print, TextSelection, LinkAnnotation, BookmarkView, ThumbnailView)
    // Document Editor (Vue)
    import {
        DocumentEditorContainerComponent as EjsDocumenteditorcontainer,
    } from '@syncfusion/ej2-vue-documenteditor'

    L10n.load(ptBR); setCulture('pt-BR')

    export default {
        name: 'Normativa',
        components: { Header, Modais, 'ejs-documenteditorcontainer': EjsDocumenteditorcontainer },
        computed: {
            showModalNormativa() {
                return this.$store.state.showModalNormativa
            },

            reload() {
                return this.$store.state.reload;
            },

            lstNormas() {
                if (this.isUsuarioContato) {
                    return [this.normaGuiaContato]
                }
                return this.$store.state.lstNormas
            },

            normasFiltradas() {
                const t = this._norm(this.pagFilter)
                if (!t) return this.lstNormas || []
                return (this.lstNormas || []).filter(n => {
                    const dsNome = this._norm(n?.dsNome)
                    const nmNorma = this._norm(n?.nmNorma)
                    const dsNorma = this._norm(n?.dsNorma)
                    const nmArq = this._norm(n?.nmArquivo)
                    const url = this._norm(n?.urlArquivo)
                    return (dsNome && dsNome.includes(t)) || (nmNorma && nmNorma.includes(t)) || (dsNorma && dsNorma.includes(t)) || (nmArq && nmArq.includes(t)) || (url && url.includes(t))
                })
            },

            editor() {
                return this.$refs.docx?.ej2Instances?.documentEditor 
            },
            user() {
                return this.$store.state.user
            },

            isUsuarioContato() {
                return String(this.user?.usuario?.dsLogin || '').trim().toLowerCase() === 'contato@sollai.com.br'
            },

            normaGuiaContato() {
                return {
                    idNorma: 'guia-utilizacao',
                    dsNome: 'Normativas - Guia de Utilização',
                    nmArquivo: 'Normativas - Guia de Utilizacao.pdf',
                    urlArquivo: '/Normativas - Guia de Utilizacao.pdf',
                    flProcessado: 2,
                    dsLoginInclusao: null,
                }
            },

            isAdmContrato() {
                return this.$store.state.isAdmContrato
            },


            isAdm() {
                return this.user?.usuarioApi?.flAdministrador
            },

            urlPdfViewer() {
                const url = this.norma?.urlArquivo
                if (!url) return ''
                if (!url.toLowerCase().includes('.pdf')) return url
                const base = url.split('#')[0]
                return `${base}#page=1&zoom=100`
            },

            nomeNormaExibido() {
                return this.nomeExibido(this.norma)
            },

            podeEditarNorma() {
                return this.podeAlterarNorma(this.norma)
            },
        },
        data: function () {
            return {
                usuario: {
                    senhaAtual: null,
                    dsSenha: null,
                    dsSenhaConfirma: null,
                },

                files: null,
                //normativas: [],
                pagFilter: '',

                norma: null,

                urlApi,
                reloadPdf: false,
                editorBusy: false,
                editandoDados: false,
                abrirEmEdicao: null,
                salvandoDados: false,
                edicao: {
                    nmNorma: '',
                    dsNorma: '',
                },
            }
        },
        methods: {
            fechar() {
                document.getElementById('tynMain').classList.toggle('main-shown')
            },
            showModal(modal, tpModal) {
                this.$store.commit('setModal', { show: !modal, tpModal: tpModal })
            },

            seleciona(norma) {
                let $this = this;

                if ($this.isUsuarioContato) {
                    $this.editorBusy = false;
                    $this.editandoDados = false;
                    $this.reloadPdf = !$this.reloadPdf;
                    $this.norma = { ...norma };
                    $this.$nextTick(function () {
                        $this.reloadPdf = !$this.reloadPdf;
                        document.getElementById('tynMain').classList.toggle('main-shown');
                    });
                    return;
                }

                $this.editandoDados = false;
                axios.get(`${urlApi}/Norma/Get/${norma.idNorma}`)
                    .then(res => {
                        $this.editorBusy = true;
                        $this.reloadPdf = !$this.reloadPdf;
                        $this.editandoDados = false;
                        $this.norma = res.data.data;
                        $this.norma.dtInclusao = moment($this.norma.dtInclusao).format('DD/MM/YYYY [às] HH:mm')
                        $this.norma.flProcessado = norma.flProcessado;
                        $this.norma.dsNome = norma.dsNome || $this.nomeExibido($this.norma);
                        if ($this.abrirEmEdicao === $this.norma.idNorma) {
                            $this.iniciarEdicao();
                            $this.abrirEmEdicao = null;
                        }
                        $this.$nextTick(function () {
                            $this.reloadPdf = !$this.reloadPdf;
                            document.getElementById('tynMain').classList.toggle('main-shown');

                            if ($this.norma.urlArquivo.includes('.doc') || $this.norma.urlArquivo.includes('.docx')) {
                                $this.abrirDocumento(norma.urlArquivo);
                            }
                            
                        });
                    })
                    .catch(res => {
                        $this.abrirEmEdicao = null;
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("erro ao carregar normativa");
                        }
                    });
            },

            podeAlterarNorma(item) {
                if (!item || this.isUsuarioContato || item.idNorma === 'guia-utilizacao') return false
                const login = this.user?.usuario?.dsLogin
                return this.isAdmContrato == 'Sim' || this.isAdm || this.user?.usuario?.idContrato == 0 || login == item.dsLoginInclusao
            },

            nomeExibido(item) {
                const nome = (item?.nmNorma || '').trim()
                if (nome) return nome
                if (item?.nmArquivo) return item.nmArquivo
                const partes = String(item?.urlArquivo || '').split('/')
                return partes[partes.length - 1] || item?.dsNome || 'Normativa'
            },

            aplicarIdentificacao(alvo, nome, descricao) {
                alvo.nmNorma = nome || null
                alvo.dsNorma = descricao || null
                alvo.dsNome = this.nomeExibido(alvo)
            },

            renomear(item) {
                this.abrirEmEdicao = item.idNorma
                if (this.norma && this.norma.idNorma === item.idNorma) {
                    this.iniciarEdicao()
                    this.abrirEmEdicao = null
                    const main = document.getElementById('tynMain')
                    if (main && !main.classList.contains('main-shown')) {
                        main.classList.add('main-shown')
                    }
                    return
                }
                this.seleciona(item)
            },

            async abrirDocumento(url) {
                if (!url) { this.setError('URL do artefato vazia.'); return }

                const ext = (url.split('?')[0].split('#')[0].split('.').pop() || '').toLowerCase()
                if (ext === 'pdf') {
                    this.setError('Este artefato está em PDF. Use o visualizador de PDF para revisão.')
                    return
                }

                this.editorBusy = true
                if (this.editor) {
                    this.editor.isReadOnly = true;
                    this.editor.enableSelection = false;
                    this.editor.enableContextMenu = false;
                    this.editor.enableSpellCheck = false;
                }

                try {
                    const { data: sfdt } = await axios.post(`${urlApi}/DOCXEditor/ImportFromUrl`, { url })
                    this.editor?.open(sfdt)
                    this.editorBusy = false
                    avisoToast('Documento carregado.', 'success')
                } catch (e) {
                    this.editorBusy = false
                    alert('erro')
                    avisoToast(e?.response?.data || e.message || 'Erro ao abrir documento no editor.', 'warning')
                }
                
            },

            load() {
                let $this = this;
                //$this.normativas = [];
                $this.files = null;
                $this.norma = null;
                if ($this.isUsuarioContato) {
                    return;
                }
                this.$store.commit('setNormativas');
            },

            removeNormativa(idNorma) {
                let $this = this;
                let dados = { idNorma: idNorma };
                Swal.fire({
                    title: 'Tem certeza que deseja remover a normativa?',
                    text: 'Esta operação não poderá ser desfeita.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não',
                    confirmButtonColor: '#83A431',
                }).then((result) => {
                    if (result.isConfirmed) {
                        $this.remover(dados);
                    }
                })
            },

            remover(dados) {
                let $this = this;
                axios.post(`${urlApi}/Norma/Delete`, dados)
                    .then(res => {
                        if (res.data.success) {
                            avisoToast("Normativa removida com sucesso.");
                            $this.load();
                        } else {
                            avisoErro("Não foi possível remover a normativa.");
                        }
                    })
                    .catch(res => {
                        if (res.response.data) {
                            $this.msgErro = res.response.data.msg + " - " + res.response.data.errors[0];
                            avisoErro(res.response.data.msg + " - " + res.response.data.errors[0]);
                        } else {
                            avisoErro("Não foi possível remover a normativa.");
                        }
                    });
            },

            download(urlArquivo, dsNome) {
                axios.post(`${urlApi}/Log/Registrar`, { cdTipoLog: 'NRM_DWN' }).catch(() => { })

                if (this.isUsuarioContato) {
                    const link = document.createElement('a');
                    link.href = urlArquivo;
                    link.setAttribute('download', dsNome?.endsWith('.pdf') ? dsNome : `${dsNome}.pdf`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    return;
                }

                var nmArquivo = "";
                var nomeArquivo = urlArquivo.split('/');
                if (nomeArquivo.length > 0) {
                    nmArquivo = nomeArquivo[nomeArquivo.length - 1];
                    nmArquivo = dsNome + "." + nmArquivo.split(".")[1];
                }

                axios({
                    url: `${urlApi}/Utilidade/BaixarArquivo?urlArquivo=${urlArquivo}&nmArquivo=${nmArquivo}`, //your url
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', nmArquivo); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
            },

            reprocessar(idNorma) {
                let $this = this;
                axios.post(`${urlApi}/Norma/Reprocessar`, { idNorma: idNorma })
                    .then(res => {
                        if (res.data.success) {
                            avisoToast("Normativa em reprocessamento.");
                            $this.load();
                        } else {
                            avisoErro("Não foi possível reprocessar a normativa.");
                        }
                    })
                    .catch(res => {
                        if (res.response.data) {
                            $this.msgErro = res.response.data.msg + " - " + res.response.data.errors[0];
                            avisoErro(res.response.data.msg + " - " + res.response.data.errors[0]);
                        } else {
                            avisoErro("Não foi possível reprocessar a normativa.");
                        }
                    });
            },

            iniciarEdicao() {
                this.edicao = {
                    nmNorma: this.norma?.nmNorma || '',
                    dsNorma: this.norma?.dsNorma || '',
                }
                this.editandoDados = true
            },

            cancelarEdicao() {
                this.editandoDados = false
            },

            salvarDados() {
                if (this.salvandoDados || !this.norma) return

                const nmNorma = (this.edicao.nmNorma || '').trim()
                const dsNorma = (this.edicao.dsNorma || '').trim()

                if (nmNorma.length > 150) {
                    avisoErro('O nome da normativa deve conter até 150 caracteres.')
                    return
                }
                if (dsNorma.length > 500) {
                    avisoErro('A descrição deve conter até 500 caracteres.')
                    return
                }

                this.salvandoDados = true
                axios.post(`${urlApi}/Norma/Atualizar`, {
                    idNorma: this.norma.idNorma,
                    nmNorma,
                    dsNorma,
                })
                    .then(res => {
                        if (res.data.success) {
                            const nome = (res.data.data?.nmNorma || '').trim()
                            const descricao = (res.data.data?.dsNorma || '').trim()
                            this.aplicarIdentificacao(this.norma, nome, descricao)
                            const item = (this.$store.state.lstNormas || []).find(n => n.idNorma === this.norma.idNorma)
                            if (item) {
                                this.aplicarIdentificacao(item, nome, descricao)
                            }
                            this.editandoDados = false
                            avisoToast('Normativa atualizada com sucesso.')
                        } else {
                            avisoErro('Não foi possível atualizar a normativa.')
                        }
                    })
                    .catch(res => {
                        if (res.response?.data) {
                            avisoErro((res.response.data.msg || 'Não foi possível atualizar a normativa.') + (res.response.data.errors?.[0] ? ' - ' + res.response.data.errors[0] : ''))
                        } else {
                            avisoErro('Não foi possível atualizar a normativa.')
                        }
                    })
                    .finally(() => {
                        this.salvandoDados = false
                    })
            },

            _norm(s) {
                return (s || '').toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim()
            },

            beforeSend(args) {
                const raw = this.$store?.state?.authToken || localStorage.getItem('authToken')
                const auth = raw?.startsWith('Bearer ') ? raw : (raw ? `Bearer ${raw}` : '')
                if (auth) args.headers = [{ Authorization: auth }]
                args.withCredentials = false
            },
        },
        mounted: function () {
            this.load();
        },

        watch: {

            reload: function () {
                this.load();
            },


        }
    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

    /* ========================================
       BOTÃO DE ADICIONAR NOVO
       ======================================== */

    .tyn-content-inner{
        padding: 0 !important;
    }

    .btn-success-add {
        background: linear-gradient(135deg, #2563eb 0%, #00d084 100%) !important;
        color: white !important;
        border: none !important;
        box-shadow: 0 2px 8px rgba(37, 99, 235, 0.2);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .btn-success-add:hover,
    .btn-success-add:focus,
    .btn-success-add:active {
        background: linear-gradient(135deg, #1d4ed8 0%, #00bf51 100%) !important;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(37, 99, 235, 0.35) !important;
        color: white !important;
        border-color: transparent !important;
    }

    .btn-success-add svg {
        fill: white !important;
    }

    [data-bs-theme=dark] .btn-success-add {
        background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%) !important;
        box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
    }

    [data-bs-theme=dark] .btn-success-add:hover,
    [data-bs-theme=dark] .btn-success-add:focus,
    [data-bs-theme=dark] .btn-success-add:active {
        background: linear-gradient(135deg, #2563eb 0%, #059669 100%) !important;
        box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4) !important;
        border-color: transparent !important;
    }

    /* ========================================
       CAMPO DE PESQUISA MODERNO
       ======================================== */
    
    .tyn-aside-search {
        padding: 0.75rem 1rem;
        margin-bottom: 0.5rem;
    }

    .search-box-modern {
        position: relative;
        display: flex;
        align-items: center;
        background: linear-gradient(135deg, rgba(248, 249, 250, 0.95) 0%, rgba(233, 236, 239, 0.95) 100%);
        border: 2px solid rgba(31, 123, 255, 0.15);
        border-radius: 14px;
        padding: 0.65rem 1rem;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

        &:hover {
            border-color: rgba(31, 123, 255, 0.3);
            box-shadow: 0 4px 12px rgba(31, 123, 255, 0.15);
            transform: translateY(-1px);
        }

        &:focus-within {
            border-color: #1f7bff;
            box-shadow: 0 0 0 4px rgba(31, 123, 255, 0.1),
                        0 4px 12px rgba(31, 123, 255, 0.2);
            transform: translateY(-2px);
            background: #ffffff;
        }
    }

    .search-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 0.75rem;
        flex-shrink: 0;
        color: #6c757d;
        transition: all 0.3s ease;

        svg {
            transition: all 0.3s ease;
        }
    }

    .search-box-modern:focus-within .search-icon {
        color: #1f7bff;

        svg {
            transform: scale(1.1);
        }
    }

    .search-input-modern {
        flex: 1;
        border: none;
        background: transparent;
        outline: none;
        padding: 0.25rem 0;
        font-size: 0.95rem;
        color: #2d3748;
        font-weight: 500;

        &::placeholder {
            color: #a0aec0;
            font-weight: 400;
        }

        &:focus {
            outline: none;
        }
    }

    /* ========================================
       ITEMS DO HISTÓRICO MODERNIZADOS
       ======================================== */
    
    .tyn-aside-item {
        border-radius: 10px;
        margin-bottom: 0.5rem;
        padding: 0.75rem;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        border: 2px solid transparent;
        cursor: pointer;

        &:hover {
            background: linear-gradient(135deg, rgba(31, 123, 255, 0.05) 0%, rgba(0, 208, 132, 0.05) 100%);
            border-color: rgba(31, 123, 255, 0.15);
            transform: translateX(4px);
            box-shadow: 0 2px 8px rgba(31, 123, 255, 0.1);

            .content {
                color: #1f7bff;
            }
        }

        &.active {
            background: linear-gradient(135deg, rgba(31, 123, 255, 0.12) 0%, rgba(0, 208, 132, 0.12) 100%);
            border-color: #1f7bff;
            box-shadow: 0 3px 10px rgba(31, 123, 255, 0.2);
            /*transform: translateX(6px);*/

            .content {
                color: #1f7bff;
                font-weight: 600;
            }
        }
    }

    .content {
        font-size: 0.9rem;
        line-height: 1.4;
        color: #2d3748;
        transition: all 0.3s ease;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .norma-lista-descricao {
        margin-top: 0.15rem;
        font-size: 0.75rem;
        line-height: 1.3;
        color: #718096;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .norma-dados {
        flex: 0 0 auto;
        padding: 0.9rem 1.25rem;
        border-bottom: 1px solid rgba(31, 123, 255, 0.12);
        background: #ffffff;
    }

    .norma-dados-view {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 1rem;
    }

    .norma-dados-texto {
        min-width: 0;
    }

    .norma-dados-nome {
        margin: 0;
        font-size: 1.05rem;
        font-weight: 600;
        color: #1a202c;
        word-break: break-word;
    }

    .norma-dados-descricao {
        margin: 0.35rem 0 0;
        font-size: 0.9rem;
        line-height: 1.45;
        color: #4a5568;
        white-space: pre-wrap;
        word-break: break-word;
    }

    .norma-dados-descricao.is-empty {
        color: #a0aec0;
        font-style: italic;
    }

    .btn-editar-norma {
        background: linear-gradient(135deg, #2563eb 0%, #00d084 100%);
        color: #fff;
        border: none;
        border-radius: 8px;
        white-space: nowrap;
    }

    .btn-editar-norma:hover,
    .btn-editar-norma:focus {
        color: #fff;
        background: linear-gradient(135deg, #1d4ed8 0%, #00bf51 100%);
    }

    .norma-dados-form .form-label {
        font-size: 0.8rem;
        font-weight: 600;
        margin-bottom: 0.25rem;
    }

    .docx-container {
        flex: 1 1 auto;
        min-height: 0;
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .tyn-media-group {
        display: flex;
        align-items: center;
        gap: 0.75rem;
    }

    .tyn-media {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        background: linear-gradient(135deg, rgba(31, 123, 255, 0.1) 0%, rgba(0, 208, 132, 0.1) 100%);
        border-radius: 8px;
        transition: all 0.3s ease;

        svg {
            fill: #1f7bff;
        }
    }

    .tyn-aside-item:hover .tyn-media {
        background: linear-gradient(135deg, rgba(31, 123, 255, 0.15) 0%, rgba(0, 208, 132, 0.15) 100%);
        transform: scale(1.05);
    }

    .tyn-aside-item.active .tyn-media {
        background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
        box-shadow: 0 2px 8px rgba(31, 123, 255, 0.3);

        svg {
            fill: white;
        }
    }

    /* Meta Info - Status Badges */
    .meta-info {
        margin-top: 0.25rem;
        display: flex;
        gap: 0.5rem;
        align-items: center;
    }

    .badge-status {
        display: inline-block;
        padding: 0.2rem 0.5rem;
        border-radius: 6px;
        font-size: 0.7rem;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    .badge-success {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        color: white;
    }

    .badge-processing {
        background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        color: white;
    }

    .badge-pending {
        background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
        color: white;
    }

    /* Dark mode items */
    [data-bs-theme=dark] .tyn-aside-item {
        &:hover {
            background: linear-gradient(135deg, rgba(59, 130, 246, 0.08) 0%, rgba(16, 185, 129, 0.08) 100%);
            border-color: rgba(59, 130, 246, 0.2);
        }

        &.active {
            background: linear-gradient(135deg, rgba(59, 130, 246, 0.15) 0%, rgba(16, 185, 129, 0.15) 100%);
            border-color: #3b82f6;
        }

        .content {
            color: #cbd5e1;
        }

        &:hover .content,
        &.active .content {
            color: #60a5fa;
        }
    }

    /* Botão de lixeira modernizado */
    .btn-pill.btn-light.btn-remover {
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        border: 1px solid #e9ecef;

        &:hover {
            background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
            border-color: transparent;
            transform: scale(1.1);
            box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);

            svg {
                fill: white !important;
            }
        }
    }

    /* ========================================
       PDF CONTAINER E VIEWER
       ======================================== */
    
    .pdf-container {
        position: relative;
        width: 100%;
        flex: 1 1 auto;
        min-height: 0;
        height: auto;
        display: flex;
        flex-direction: column;
    }

    .pdf-viewer {
        flex: 1;
        width: 100%;
        height: 100%;
        background: #f5f5f5;
        border-radius: 0;
        overflow: hidden;

        iframe {
            border: none;
            display: block;
        }
    }

    /* Alertas Flutuantes */
    .alert-floating {
        position: absolute;
        top: 1rem;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1000;
        min-width: 300px;
        max-width: 600px;
        animation: slideDown 0.3s ease;

        .alert {
            margin: 0;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            border-radius: 10px;
        }
    }

    @keyframes slideDown {
        from {
            opacity: 0;
            transform: translateX(-50%) translateY(-20px);
        }
        to {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
        }
    }

    /* Barra de Ações Flutuante */
    .action-bar-floating {
        position: absolute;
        top: 1rem;
        right: 1rem;
        z-index: 1000;
        display: flex;
        gap: 0.5rem;
        animation: fadeIn 0.3s ease;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    .btn-action {
        width: 42px;
        height: 42px;
        border-radius: 10px;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

        svg {
            transition: all 0.3s ease;
        }

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);

            svg {
                transform: scale(1.1);
            }
        }

        &:active {
            transform: translateY(0);
        }
    }
/*
    .btn-download {
        background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
        color: white;

        svg {
            fill: white;
        }

        &:hover {
            background: linear-gradient(135deg, #1d4ed8 0%, #00bf51 100%);
            box-shadow: 0 4px 12px rgba(31, 123, 255, 0.4);
        }
    }
*/
    .btn-delete {
        background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
        color: white;

        svg {
            fill: white;
        }

        &:hover {
            background: linear-gradient(135deg, #c82333 0%, #a71d2a 100%);
            box-shadow: 0 4px 12px rgba(220, 53, 69, 0.4);
        }
    }

    .is-loading {
        position: relative;
    }

    .editor-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.95);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        backdrop-filter: blur(4px);
    }
    .overlay-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
    }

    .overlay-content p {
        font-size: 1.1rem;
        font-weight: 600;
        color: #235FE8;
        margin: 0;
    }

    .spinner {
        width: 50px;
        height: 50px;
        animation: rotate 2s linear infinite;
    }

    .spinner circle {
        stroke: #235FE8;
        stroke-linecap: round;
        animation: dash 1.5s ease-in-out infinite;
    }
    /* ========================================
       DARK THEME
       ======================================== */

    [data-bs-theme="dark"] .search-box-modern {
        background: linear-gradient(135deg, #1e2330 0%, #252b3d 100%);
        border-color: rgba(96, 165, 250, 0.2);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);

        &:hover {
            border-color: rgba(96, 165, 250, 0.35);
            box-shadow: 0 4px 12px rgba(96, 165, 250, 0.2);
        }

        &:focus-within {
            background: linear-gradient(135deg, #252b3d 0%, #2d3548 100%);
            border-color: #60a5fa;
            box-shadow: 0 0 0 4px rgba(96, 165, 250, 0.15),
                        0 4px 12px rgba(96, 165, 250, 0.3);
        }
    }

    [data-bs-theme="dark"] .search-icon {
        color: #9ca3af;
    }

    [data-bs-theme="dark"] .search-box-modern:focus-within .search-icon {
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .search-input-modern {
        color: #f3f4f6;
        font-weight: 500;

        &::placeholder {
            color: #6b7280;
        }
    }

    [data-bs-theme="dark"] .tyn-media {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.12) 0%, rgba(16, 185, 129, 0.12) 100%);

        svg {
            fill: #60a5fa;
        }
    }

    [data-bs-theme="dark"] .tyn-aside-item:hover .tyn-media {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.2) 0%, rgba(16, 185, 129, 0.2) 100%);
    }

    [data-bs-theme="dark"] .tyn-aside-item.active .tyn-media {
        background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);

        svg {
            fill: white;
        }
    }

    [data-bs-theme="dark"] .btn-pill.btn-light {
        background: linear-gradient(135deg, #1e2330 0%, #252b3d 100%);
        border-color: rgba(255, 255, 255, 0.12);

        svg {
            fill: #e5e7eb !important;
        }

        &:hover {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
            border-color: transparent;
            box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);

            svg {
                fill: white !important;
            }
        }
    }

    [data-bs-theme="dark"] .pdf-viewer {
        background: #1a1d29;
    }

    [data-bs-theme="dark"] .norma-dados {
        background: #1a1d29;
        border-bottom-color: rgba(96, 165, 250, 0.18);
    }

    [data-bs-theme="dark"] .norma-dados-nome {
        color: #f3f4f6;
    }

    [data-bs-theme="dark"] .norma-dados-descricao {
        color: #d1d5db;
    }

    [data-bs-theme="dark"] .norma-lista-descricao,
    [data-bs-theme="dark"] .norma-dados-descricao.is-empty {
        color: #9ca3af;
    }

    /* ========================================
       RESPONSIVIDADE
       ======================================== */
    
    @media (max-width: 767px) {
        .btn-success-add {
            width: 36px;
            height: 36px;
            padding: 0.5rem;
        }

        .btn-success-add svg {
            width: 14px;
            height: 14px;
        }

        .search-box-modern {
            padding: 0.55rem 0.875rem;
            border-radius: 12px;
        }

        .search-input-modern {
            font-size: 0.875rem;
        }

        .search-icon svg {
            width: 16px;
            height: 16px;
        }

        .tyn-aside-item {
            padding: 0.65rem;
        }

        .content {
            font-size: 0.85rem;
        }

        .tyn-media {
            width: 32px;
            height: 32px;
        }

        .action-bar-floating {
            top: 0.5rem;
            right: 0.5rem;
            gap: 0.35rem;
        }

        .btn-action {
            width: 36px;
            height: 36px;

            svg {
                width: 16px;
                height: 16px;
            }
        }

        .alert-floating {
            min-width: 250px;
            top: 0.5rem;
        }
    }

    @media (min-width: 768px) and (max-width: 1300px) {
        .btn-success-add {
            width: 40px;
            height: 40px;
        }

        .search-box-modern {
            padding: 0.6rem 0.95rem;
        }

        .search-input-modern {
            font-size: 0.9rem;
        }
    }



</style>

